// extracted by mini-css-extract-plugin
module.exports = {"listItem":"LinksList_listItem__UilhE","subtitle":"LinksList_subtitle__OXD0s"};